export default "__VITE_ASSET__bcfe0738__"